import {
  determineFullTradeData,
  returnAllTradeDetailsFromGenericParams,
  returnOPLegFormThisTrade,
  returnRPLegFromThisTrade,
} from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { SecurityTypeCode } from "@/lib/interfaces and Enums/ENUMSecurityTypeCode";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import tradeDataStore from "@/store/tradeDataStore";
import { isCPIEditable } from "../actionSummaryColDefHelperFunctions";
import { useTheme } from "next-themes";
import { returnDecimalFormatting } from "@/lib/globalFormatterHelper";

import { StrategyType } from "@/lib/interfaces and Enums/ENUMStrategyType";

export function returnCPIValueToRender(
  params: any,
  thisTrade: ExecutionStrategy,
) {
  if (!thisTrade) {
    return;
  }
  const { isOp, isOutright, isLeg, isER } =
    returnAllTradeDetailsFromGenericParams(params);

  const helperObject = {
    params,
    thisTrade,
    isOp,
    isER,
    isOutright,
    isLeg,
  };

  if (isOp) {
    const thisOPLeg = returnOPLegFormThisTrade(helperObject);
    if (thisOPLeg?.securityType != SecurityTypeCode.ZCS) {
      return; // Early return if Leg is NOT a ZCS
    }
    //ER
    // No Return
    if (isLeg || isOutright) {
      return thisOPLeg?.cpi;
    }
  } else {
    const thisRPLeg = returnRPLegFromThisTrade(helperObject);
    if (thisRPLeg?.securityType != SecurityTypeCode.ZCS) {
      return; // Early return if Leg is NOT a ZCS
    }
    //RP
    //ER
    if (isLeg || isOutright) {
      return thisRPLeg?.cpi;
    }
  }
  // Fall back static data.
  return params.data.cpi ? params.data.cpi : "";
}

export function isShowingCPI() {}

const CPICellRenderer = (params: any) => {
  const { theme } = useTheme();

  const fullTradeData = determineFullTradeData(params);
  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade =
    currentTradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;
  if (!thisTrade) return null;

  const isEditable = isCPIEditable({
    esid: fullTradeData?.esid,
    thisTradePassed: thisTrade,
  });

  function editableStyle() {
    if (isEditable && theme == "light") {
      return "inputCellOtherLight roundedInputCell";
    } else if (isEditable && theme == "dark") {
      return "inputCellOtherDark roundedInputCell";
    }
  }

  const valueToRender = returnCPIValueToRender(params, thisTrade);

  // Outrights will always be a ZCS.

  let showCPI = false;
  if (thisTrade.strategyType == StrategyType.Structure) {
    if (params.data.securityType == SecurityTypeCode.ZCS) {
      showCPI = true;
    }
  } else {
    showCPI = true;
  }

  return (
    <div
      className={`${showCPI ? `ag-roundedInputStyle ${editableStyle()}` : ""}`}
    >
      {valueToRender && valueToRender > -1
        ? returnDecimalFormatting(Number(valueToRender))
        : null}
      {/* Currently passing in no decimal rule - should return at default of 6 dp max.  */}
    </div>
  );
};

export default CPICellRenderer;
